import { render, staticRenderFns } from "./RatingistCheckIndex.vue?vue&type=template&id=339af7f0"
import script from "./RatingistCheckIndex.vue?vue&type=script&lang=js"
export * from "./RatingistCheckIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports